import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { exchangedTypesOptions } from './constants'

const ExchangedTypeSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Tipo de cambio solicitado')}
      value={value || []}
      multiple
      menuItems={exchangedTypesOptions.map(o => ({ ...o, label: t(o.label) }))}
      handleChange={e => onChange(e.target.value)}
    />
  )
}

export default ExchangedTypeSelector
